import { OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';
import { toAmountKeySegment } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification-amount.business';
import { OperatorCustomNotificationConfirmationTexts } from 'modules/settings/pods/settings-operator-custom-notifications/components/operator-custom-notifications-confirmation-modal/operator-custom-notifications-confirmation-modal.model';
import { OperatorCustomNotificationAction } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';

export const getConfirmationTexts = (
    action: OperatorCustomNotificationAction,
    selectedAmount: number
): OperatorCustomNotificationConfirmationTexts => {
    const amount = toAmountKeySegment(selectedAmount);

    return {
        headerText: `${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.${action}.modal.${amount}.title`,
        bodyText: `${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.${action}.modal.${amount}.description`,
        confirmText: `${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.actions.${action}`,
    };
};
